//A reducer is a function that determines changes to an application's state.
//It uses the action it receives to determine this change.  Redux is used
//to help manage the applications state changes in a single store so that
//they behave consistently.


const initialState = {
    authError: null,
    authToken: null,
    authResetPassword: 'sent',
    authResetPasswordEmail: null,
    authResetPasswordError: null,
    uid: null,
    email: null,
}

//This reducer is just a function
//It takes in a state and an action. The first time it runs the state is
//not loaded up yet so we need to pass in a default value state at the start.
const authReducer = (state = initialState, action) => {

    //use switch to determine the action type being passed via the "authAction.js"
    switch(action.type){

        case 'NULL_RESET_PASSWORD':
            return{
                ...state,
                authError: null,
                authToken: null,
                authResetPassword: null,
                authResetPasswordEmail: null,
                authResetPasswordError: null,
            }


        case 'RESET_PASSWORD':

            return{
                ...state,
                authError: null,
                authToken: null,
                authResetPassword: 'sent',
                authResetPasswordEmail: action.email,
                authResetPasswordError: null,
            }


            case 'RESET_PASSWORD_ERROR':
                return{
                    ...state,
                    authError: null,
                    authToken: null,
                    authResetPassword: null,
                    authResetPasswordEmail: null,
                    authResetPasswordError: action.err.message,
                }


        case 'LOGIN_ERROR':

            return{
                ...state,
                authError: 'Login failed with the email and password provided.',
                authToken: action.authToken,
                authResetPassword: null,
                authResetPasswordEmail: null,
            }
         
            
        case 'LOGIN_SUCCESS':
            return{
                ...state,
                authError: null,
                authToken: action.authToken,
                authResetPassword: null,
                authResetPasswordEmail: null,
            }


        case 'CENTRAL_LOGIN_SUCCESS':

            return{
                ...state,
                authError: null,
                authToken: action.authToken,
                authResetPassword: null,
                authResetPasswordEmail: null,
                uid: action.uid,
                email: action.email,
            }


        case 'RELOAD_TOKEN_WITHOUT_LOGOUT':

        
            return{
                ...state,
                authError: null,
                authToken: action.authToken,
                authResetPassword: null,
                authResetPasswordEmail: null,
            }


        case 'FORCE_REFRESH_CENTRAL_LOGIN_TOKEN':

            return{
                ...state,
                authToken: action.authToken,
                uid: action.uid,
                email: action.email,
            }


        case 'SIGNOUT_SUCCESS':

            return{
                authError: null,
                authToken: null,
                authResetPassword: null,
                authResetPasswordEmail: null,
                uid: null,
                email: null,
            }


        case 'SIGNUP_SUCCESS':

            return{
                ...state,
                authError: null,
                authToken: action.authToken,
                authResetPassword: null,
                authResetPasswordEmail: null,
            }
        

        case 'SIGNUP_ERROR':

            return{
                ...state,
                authError: action.err.message,
                authToken: action.authToken,
                authResetPassword: null,
                authResetPasswordEmail: null,
            }
        

        default:

            return state;
            
    }


}

export default authReducer